import { Dropdown, Button } from "@endya-conformite/ui-kit";
import ChevronDown from "@endya-conformite/ui-kit/src/assets/icons/chevron-down.svg?react";
import Person from "@endya-conformite/ui-kit/src/assets/icons/person.svg?react";
import { useSession } from "@src/data/session/UserSessionContext";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import style from "./UserMenu.module.scss";

export function UserMenu() {
  const session = useSession();
  const navigate = useNavigate();

  const handleLogout = useCallback(async () => {
    try {
      await session.logout();
    } catch (e) {
      console.error("Error while logging out", e);
    }
    navigate("/login");
  }, [session, navigate]);

  return (
    <Dropdown
      dismissOnClick
      withIcon={false}
      variant="outline-pop"
      placement="bottom-start"
      ariaLabel="Menu utilisateur"
      content={
        <div className={style.actionButtonInnerWrapper}>
          <span className={style.actionPersonIcon}>
            <Person />
          </span>
          <ChevronDown className={style.chevronDownAction} />
        </div>
      }
      className={style.actionButton}
    >
      {({ close }) => (
        <div>
          {session.endyaAdmin && (
            <Button
              variant="text"
              onClick={() => {
                close();
                navigate("/admin/questionnaires");
              }}
            >
              Administration des formulaires
            </Button>
          )}
          <Button
            variant="text"
            onClick={() => {
              handleLogout()
                .catch((e) => console.error("Error while logging out", e))
                .finally(close);
            }}
            className={style.disconnectButton}
          >
            Me déconnecter
          </Button>
        </div>
      )}
    </Dropdown>
  );
}
